import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { useMBDContext } from '../common/MBD/useMBDContext';

import type { Filter } from '@skyscanner-internal/landing-pages-shared-types/types-shared/FilterLinks';

import STYLES from './FilterLinksItem.module.scss';

type FilterLinksItemProps = Filter & {
  categoryIndex: number;
  trackingVariant: 'desktop' | 'mobile';
};

const FilterLinksItem = ({
  categoryIndex,
  links,
  name,
  trackingVariant,
}: FilterLinksItemProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const mbdComponentName = `${rawComponentName}_filter`;

  return (
    <div className={STYLES.Category}>
      <BpkText tag="h3" textStyle={TEXT_STYLES.heading5}>
        {name}
      </BpkText>
      <div className={STYLES.Category__FilterList}>
        {links.map((link, linkIndex) => (
          <BpkLink
            key={link.url}
            href={link.url}
            {...link.linkAttributes}
            data-tracking-element-id={`${mbdComponentName}_${trackingVariant}_${categoryIndex}_${linkIndex}`}
            data-tracking-common-params={buildMBDParam(mbdComponentName, {
              filter_name: link.name.slice(0, 40),
            })}
          >
            {link.name}
          </BpkLink>
        ))}
      </div>
    </div>
  );
};

export default FilterLinksItem;
